<template>
  <div class="block-information clearfix" v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java.png">
    </div>
    <div class="fl">
      <span class="angle"></span>
      <div style="display:flex;" v-if="!$route.params.address">
      <div class="tit" style="font-size:16px;line-height: 32px;" @click="$router.push(`/`)">
        {{$t("HyperBlockList")}}
      </div>
      <div class="tit" style="margin-left:30px;border-bottom: 2px solid #e37200;" @click="$router.push(`/TxList`)">
        Transactions
      </div>  
     </div>   
     <div>
      <div class="tit van-ellipsis" style="line-height: 32px;font-size:16px;" v-if="$route.params.address">
        Address <span style="color: #EB7326">{{ this.address }}</span>
      </div>
      <div style="font-size:16px;"><span v-if="!$route.params.address && page ==1">Latest 20 Transactions</span><span v-if="!$route.params.address && page > 1">Latest {{ (page - 1) * page_size + 1 }} - {{ (page - 1) * page_size + count }} Transactions</span><span v-if="$route.params.address">{{ total_count }} Transactions</span></div>
    </div> 
      <section id="tab" class="section2">
        
        <div style="width: 100%;">
          <table class="table">
            <tr>
              <th>No</th>
              <th>Tx ID</th>
              <!-- HBlock -->
              <!-- <th>Nonce</th> -->
              <th>Sender</th>
              <th>Contract</th>
              <!-- LChains -->
              <th>Block ID</th>
              <th>Status</th>
              <th style="width:200px;">Time</th>
            </tr>
            <tr
            v-for="(item,index) in transactions"
            :key="index"
            @click="$router.push(`/TxView/${item.tx_id}`)">
              <td>
                {{ (page-1) * page_size + index + 1 }}
              </td>
              <td>{{addressThumbnail(item.tx_id)}}</td>
              <!-- <td>{{item.nonce}}</td> -->
              <td>{{addressThumbnail(item.sender)}}</td>
              <td>{{addressThumbnail(item.contract)}}</td>
              <td>{{ item.hyperchain ? `[${item.hyperchain.hid},${item.hyperchain.chain_num},${item.hyperchain.block_id}]` : '' }}</td>
              <td>{{item.status}}</td>
              <td style="width:200px;">{{$retTime(item.tx_time*1000)}}</td>
            </tr>
          </table>
        </div>
      </section>
      <pages
        toLink="TxList"
        :pageCount="pageCount"
        :page="page"
        :address="address">
      </pages>
    </div>
  </div>
</template>
<script>
import pages from '@/components/pages.vue'
export default {
  components:{
    pages
  },
  data(){
    return{
      address: '',
      pageCount:'',
      hyperblocks:[],
      page:1,
      page_size:20,
      loading: true,
      transactions: [],
      latest: true,
      total_count: 0,
      count: 0
    }
  },
  watch:{
    $route(){
      this.init();
    }
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      this.address = this.$route.params.address ? this.$route.params.address : '';
      let page = this.$route.params.page ? this.$route.params.page  : 1;
      let url = `query/transaction/lastest/?page=${ page }&page_size=${this.page_size}`;
      if (this.address && this.address.length > 0) {
        url = `query/transaction/search/?address=${ this.address }&page=${ page }&page_size=${this.page_size}`;
        this.latest = false;
      }
      this.$http({
        url: url,
        baseURL: process.env.VUE_APP_BLOCKCHAIN,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.status == 200){
          this.transactions = data.data.list;
          this.pageCount = data.data.pages.page_count;
          this.total_count = data.data.pages.total_count;
          this.count = data.data.pages.count;
          if(data.data.pages.page<1){
            this.page = 1;
          }else{
            this.page = Number(data.data.pages.page);
          }
        }
        window.scrollTo(0,0);
        this.loading = false;
      })
    },
    addressThumbnail(address){
      if(!address) return;
      if(address.length < 12) return address;
      let first = address.substring(0,6);
      let last = address.substring(address.length-4);
      return `${ first }...${ last }`;
    },    
  }
}
</script>
<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .section2 .table{
      width: 800px!important;
    }
  }
</style>
